// OLG's Ministry Scheduler Pro web-terminal login — the one place a
// volunteer actually acts on their schedule: requesting a sub, picking
// up an open sub-request, editing availability. Sacristy is read-only
// against MSP, so anything write-shaped links out to here.
//
// This is the parish's dedicated sign-in URL (no per-minister token —
// an earlier version carried an `?ath=` authority JWT and was
// corrected; don't reintroduce one). MSP publishes no deeper
// web-terminal paths in its API docs, so link to the terminal itself
// and name the tab in the copy rather than guessing at a deep link
// that could 404.
//
// Hardcoded and single-tenant, matching the same URL in
// content/parishes/our-lady-of-grace/help.md — that's markdown content
// and can't import this, so those two are the only copies; keep them
// in sync. Lift to a parish field (msp_slug + instance id) when
// Sacristy AI goes multi-parish.
export const MSP_WEB_TERMINAL_URL =
  "https://secure.rotundasoftware.com/30/web-terminal/login/ourladyofgrace";

// MSP's generic sign-in — parish-neutral. Where a parish without an
// msp_slug on file lands instead of another parish's terminal.
export const MSP_GENERIC_LOGIN_URL = "https://www.ministryschedulerpro.com/login.php";

// Resolves the MSP login link from a payload's mspLoginUrl field:
//   string  → the parish's own terminal (parishes.msp_slug is set)
//   null    → new worker, no slug on file → generic MSP login
//   absent  → old worker (predates the field) → the pilot hardcode,
//             preserving OLG's exact behavior during deploy skew
export function resolveMspLoginUrl(payloadUrl: string | null | undefined): string {
  if (payloadUrl) return payloadUrl;
  if (payloadUrl === null) return MSP_GENERIC_LOGIN_URL;
  return MSP_WEB_TERMINAL_URL;
}
